var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[_c('div',{staticClass:"timer__item"},[_vm._v(_vm._s(_vm.formatedTime))]),_c('span',{staticClass:"timer__drop"},[_vm._v("-")]),_c('div',{staticClass:"timer__item"},[_vm._v(_vm._s(_vm.formatedTotalTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }